export default __webpack_public_path__ + "static/media/logo-njio_logo.32750a92.svg";